var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"gradient-bar",style:(_vm.gradientStyle)}),_c('div',{staticClass:"temperature-bar"},_vm._l((_vm.gradientTemps),function(item,index){return _c('div',{key:index,staticClass:"temperature-item"},[_vm._v(" "+_vm._s(item.F)+"℉ ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }